import { PDFExport } from "@progress/kendo-react-pdf";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import "./PurchaseInvoice.css";

import InvoiceFooter from "../../../.././../../Assets/Images/Invoice-Footer.png";
import InvoiceHeader from "../../../.././../../Assets/Images/Invoice-Hader.png";
import { LocationContext } from "../../../../../../CustomHelper/Helper";

export default function PurchaseInvoice() {
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);
  const pdfExportComponent = useRef(null);
  const handleButtonClick = (event) => {
    pdfExportComponent.current.save();
  };

  const { id } = useParams();

  const [orderView, setOrderListView] = useState("");
  
  useEffect(() => {
    axios
      .get(`/api/user/marketplace/order/product-list/view/${id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setOrderListView(res.data.orderListView);
        }
      });
  }, []);

  const totalTax = (tax, totalPrice) => { 
    return (tax * totalPrice) / 100; 
  };



  return (
    <div className="container">
      <div className="row">
        {" "}
        <div className="col-12">
          {" "}
          <PDFExport ref={pdfExportComponent} paperSize="A3">
            <div className="bg-light d-flex justify-content-center">
              <div className="card shadow p-2">
                <div>
                  <img src={InvoiceHeader} alt="" className="w-100" />
                </div>
                <div className="d-flex justify-content-end pe-2">
                  <div className="my-3">
                    <p className="fontText">Order ID: #{orderView?.order_no}</p>
                    <p className="fontText">
                      Order Date: {moment(orderView?.created_at).format("LL")}{" "}
                      {moment(orderView?.created_at).format("LT")}
                    </p>
                  </div>
                </div>
                <div className="viewMargin starAndView ps-2">
                  <div className="">
                    <h4 className="sueprStarHeaderTitle">
                      HelloSuperstars.com
                    </h4>
                    <p className="fontText">Adress: Dhaka, Bangladesh</p>
                    <p className="fontText">
                      Email: support@hellosuperstars.com
                    </p>
                    <p className="fontText">Phone: +880-1784-502680</p>
                  </div>

                  <div className="">
                    <h4 className="sueprStarHeaderTitle">
                      Delivery Information
                    </h4>
                    <p className="fontText">
                      Country Name : {orderView?.deliverycharge?.country}
                    </p>
                    <p className="fontText">
                      Company Name : {orderView?.deliverycharge?.courier_company}
                      </p>
                  </div>

                  <div className="pe-2">
                    <div>
                      <h4 className="sueprStarHeaderTitle">
                        {orderView.user?.first_name} {orderView.user?.last_name}
                      </h4>
                      <p className="fontText">
                        Adress: {orderView?.area}, {orderView.city?.name},{" "}
                        <br /> {orderView.state?.name},{orderView.country?.name}
                      </p>
                      <p className="fontText">Email: {orderView.user?.email}</p>
                      <p className="fontText">Phone: {orderView?.phone}</p>
                    </div>
                  </div>
                </div>
                <div className="tableContainer">
                  <Table striped bordered hover>
                    <thead className="tableHead">
                      <tr>
                        <th className="fontText">Product Name</th>
                        <th className="fontText">Superstar Name</th>
                        <th className="fontText">Qty</th>
                        <th className="fontText">Unit Price</th>
                        <th className="fontText">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fontText">
                          {orderView.marketplace?.title}
                        </td>
                        <td className="fontText">
                          {orderView.star?.first_name}{" "}
                          {orderView.star?.last_name}
                        </td>
                        <td className="fontText">{orderView?.items}</td>
                        <td className="fontText">
                          {paymentCountWithSymbol(orderView?.unit_price)}
                        </td>
                        <td className="fontText">
                          {paymentCountWithSymbol(
                            orderView?.items * orderView?.unit_price
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="grandTotalDiv pe-2">
                  <div className="starAndView shippingCostDiv">
                    <div className="mx-4">
                      <p className="fontText">Sub Total : </p>
                      <p className="fontText">Delivery Charge : </p>
                      <p className="fontText">Total Tax : </p>
                    </div>
                    <div className="">
                      <p className="fontText">
                        {paymentCountWithSymbol(
                          orderView?.items * orderView?.unit_price
                        )}
                      </p>
                      <p className="fontText">
                        {paymentCountWithSymbol(orderView?.deliverycharge?.courier_charge)}
                      </p>
                      <p className="fontText">
                        {paymentCountWithSymbol(orderView?.tax)
                        
                        // paymentCountWithSymbol(
                        //   totalTax(
                        //     orderView?.tax,
                        //     orderView?.items * orderView?.unit_price
                        //   )
                        // )
                        }
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="underLineTotal"></div>
                </div>
                <div className="d-flex justify-content-end pe-2">
                  <div className="starAndView">
                    <div className="my-2 mx-4">
                      <h6 className="fontText">Grand Total</h6>
                    </div>
                    <div className="my-2">
                      <h6 className="fontText">
                        {paymentCountWithSymbol(orderView?.total_price)}
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <h2 className="thankBussiness">
                    Thank you for your business
                  </h2>
                </div>

                <div className="paymentInfoMargin ps-2">
                  <h5 className="sueprStarHeaderTitle">Payment Info</h5>
                  <p className="fontText">Account: {orderView?.card_no} </p>
                  <p className="fontText">
                    A/C Name: {orderView?.holder_name}{" "}
                  </p>
                  <p className="fontText">
                    Payment status:{" "}
                    {orderView?.payment_status == 1 ? "Paid" : "Pending"}
                  </p>
                </div>

                <div className="starAndView px-2">
                  <div className="">
                    <div className="">
                      {" "}
                      <h5 className="sueprStarHeaderTitle">
                        Terms & Conditions
                      </h5>
                      <p className="fontText">
                        <Markup
                          content={orderView.marketplace?.terms_conditions}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div>
                      <div className="underLine"></div>
                      <h5 className="mt-2">Authorised Sign</h5>
                    </div>
                  </div>
                </div>

                <div>
                  <img src={InvoiceFooter} alt="" className="w-100" />
                </div>

                <div></div>
              </div>
            </div>
          </PDFExport>
        </div>
      </div>
      <div className="d-flex justify-content-center my-4">
        <Button primary={true} onClick={handleButtonClick}>
          Download Pdf
        </Button>
      </div>
    </div>
  );
}
